import React, { useEffect, useState } from 'react';
import addonData from '../data/addonData.json';
import productData from '../data/productData.json';
import ProductCard from './ProductCard';

interface RelatedItem {
    releaseId: number;
    variationId?: number;
    addonId?: number;
}

interface RelatedGroupProps {
    relatedItems: RelatedItem[];
}

const RelatedGroup: React.FC<RelatedGroupProps> = ({ relatedItems }) => {

    const itemsPerPage = 4;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [relatedItems]);

    // Create ProductCards for each related item
    const relatedCards = relatedItems.map((item, index) => {
        if ('addonId' in item && item.addonId !== undefined && item.variationId !== undefined) {
            const addon = addonData.find(
                a =>
                    a.releaseId === item.releaseId &&
                    a.variationId === item.variationId &&
                    a.addonId === item.addonId
            );
            if (!addon) return null;

            return (
                <ProductCard
                    key={addon.addonId}
                    id={addon.addonId}
                    title={addon.title}
                    slug={addon.slug}
                    description=""
                    thumbnailUrl={addon.thumbnailUrl}
                    version={addon.version}
                    datePosted={addon.datePosted}
                    dateUpdated={addon.dateUpdated}
                    game={addon.game}
                    tags={[]}
                    isAddonCard={true}
                />
            );
        }
        else {
            // If there's only a releaseId, assume it's a product
            const product = productData.find(p => p.id === item.releaseId);
            if (!product) return null;

            return (
                <ProductCard
                    key={product.id}
                    id={product.id}
                    title={product.title}
                    slug={product.slug}
                    description=""
                    thumbnailUrl={product.thumbnailUrl}
                    version={product.version}
                    datePosted={product.datePosted}
                    dateUpdated={product.dateUpdated}
                    game={product.game}
                    tags={product.tags}
                />
            );
        }
        
    }).filter(Boolean); // Remove any nulls

    if (relatedCards.length === 0) return null;

    const totalPages = Math.ceil(relatedCards.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentCards = relatedCards.slice(startIndex, startIndex + itemsPerPage);

    const handlePageClick = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="mt-5">
            <h1 className="kanit-extrabold">Related</h1>
            <div className="card dark-mode-3 p-3 row release-info-container">
                {currentCards}

                {totalPages > 1 && (
                    <nav aria-label="Related pagination" className="mt-4">
                        <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <a className="page-link" onClick={() => handlePageClick(currentPage - 1)}>
                                    &laquo;
                                </a>
                            </li>

                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
                                    <a className="page-link" onClick={() => handlePageClick(page)}>
                                        {page}
                                    </a>
                                </li>
                            ))}

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <a className="page-link" onClick={() => handlePageClick(currentPage + 1)}>
                                    &raquo;
                                </a>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </div>
    );
};

export default RelatedGroup;

